import PropTypes from 'prop-types';
import { createContext, useState, useMemo } from 'react';
// hooks

// ----------------------------------------------------------------------

const initialState = {
  mutuelles: [],
  tarifs: []
};

const OptionsContext = createContext(initialState);

OptionsProvider.propTypes = {
  children: PropTypes.node
};

function OptionsProvider({ children }) {
  const [options, setOptions] = useState(initialState);

  // Memoize context value to prevent unnecessary re-renders of consumers
  const contextValue = useMemo(() => ({
    options,
    setOptions
  }), [options]);

  return (
    <OptionsContext.Provider value={contextValue}>
      {children}
    </OptionsContext.Provider>
  );
}

export { OptionsProvider, OptionsContext };
